// @ts-strict-ignore
import React from 'react'
import { actionAtom } from 'atoms/atoms'
import { useAtomValue } from 'jotai'
import { useTranslation } from 'react-i18next'
import {
  Box,
  Button,
  Box as Card,
  DataListItem,
  Box as DetailsContainer,
  Illustration,
} from '@node-space/ui-components'
import { ellipseMiddleText } from '@node-space/utils'

export const MerchantDetails = () => {
  const { t } = useTranslation()
  const action = useAtomValue(actionAtom)
  const merchant = action?.meta?.merchant

  return (
    <Box flexCol gapY={32} width="full">
      <Box flexCol align="center" gapY={16} className="max-w-[500px] mx-auto">
        <Illustration name="HandsClapping" color="success" />
        <h1 className="text-h1 text-foreground-prominent text-center">
          {t('merchantCreated', { merchantName: merchant?.displayName })}
        </h1>
      </Box>
      <Card background="subtle" padding={16}>
        <DetailsContainer flexCol align="center" gapY={8}>
          <DataListItem body={merchant?.wallet?.currency?.name} id={1} title={t('currency')} />
          <DataListItem
            body={merchant?.merchantId}
            id={2}
            title={t('merchantId')}
            copyText={merchant?.merchantId}
          />
          {!!merchant?.secret && (
            <DataListItem
              body={ellipseMiddleText(merchant?.secret ?? '', 15, 15)}
              id={3}
              title={t('secretKey')}
              copyText={merchant?.secret}
            />
          )}
          {!!merchant?.webhookUrl && (
            <DataListItem
              body={merchant?.webhookUrl}
              id={4}
              title={t('webhookUrl')}
              copyText={merchant?.webhookUrl}
            />
          )}
        </DetailsContainer>
      </Card>

      <Box flex justify="center">
        <Button testId="done" onClick={action?.onClose}>
          {t('done')}
        </Button>
      </Box>
    </Box>
  )
}
